import React from 'react'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import { Container, Row, Col, Button, Label, Input} from 'reactstrap';
import moment from 'moment';
import {clearReportReservationsList} from './actions/reportActions'
import {fetchMB} from './utils/MojBus'
import {formatCurrency} from './utils/Strings'


const REFUND_STATE_NEW = 'NEW'
const REFUND_STATE_SHOWFORM = 'SHOWFORM'
const REFUND_STATE_PENDING = 'PENDING'
const REFUND_STATE_CALCRESULT = 'CALCRESULT'
const REFUND_STATE_RESULT = 'RESULT'
const REFUND_STATE_ERROR = 'ERROR'
const REFUND_STATE_NOTLOGGED = 'NOTLOGGED'

const mapStateToProps = state => {
  return {
    isLogged: state.user.isLogged,
    agentLogin: state.user.agentLogin,
    reservations: state.report.reservations,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClearResList: () => {
      dispatch(clearReportReservationsList())
    }
  }
}
class Refund extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      currState: REFUND_STATE_NEW,
      formClass: props.formClass || 'loginWidget',
      idReservation: this.props.match.params.idReservation,
      resData: null,
      refundData: null,
      errorDesc:'-',
      isFullRefund: 'false',
      seatsRefundQtyNormal: 0,
      seatsRefundQtyReduced: 0,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCalcSubmit = this.handleCalcSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }
  componentDidMount() {
    this.collectData();
  }

   handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    //console.log(name + ' -> ' + value);
  }
  setError(desc){
    this.setState({
        errorDesc: desc,
        currState: REFUND_STATE_ERROR,
      });
  }
  collectData(){
    if (!this.props.isLogged)
      return this.setState({
          currState: REFUND_STATE_NOTLOGGED,
        })
    var idRes=this.state.idReservation
    if (idRes<=0)
      return this.setError("Błędne wskazanie rezerwacji")

    var resArr=this.props.reservations;
    for (var i=0; i< resArr.length; i++){
      var res=resArr[i]
      // eslint-disable-next-line
      if (res.idReservation == idRes)
        return this.setState({
          resData: res,
          seatsRefundQtyNormal: res.qtyNormal,
          seatsRefundQtyReduced: res.qtyReduced,
          currState: REFUND_STATE_SHOWFORM,
        })
    }

    console.log("resArr, szuk Id:" + idRes);
    console.log(resArr);

    this.setState({
        errorDesc: "Nie znaleziono danych rezerwacji do zwrotu",
        currState: REFUND_STATE_ERROR,
      });
  }

  renderLogout(){
    if (!this.props.isLogged)
      return <Redirect to='/'/>;
  }

  renderNew(){
    return (
      <div>
        <p>Zbieram dane rezerwacji {this.state.idReservation}</p>
      </div>
    )
  }

  handleCancel(event) {
    event.preventDefault();
    this.props.history.goBack()
//    this.props.onCancel();
  }
  handleSubmit(event) {
    event.preventDefault();
    this.handleRefundAction(true)
  }
  handleCalcSubmit(event) {
    event.preventDefault();
    this.handleRefundAction(false)
  }
  handleRefundAction(save=true) {
    //walidacja
    if ((this.state.seatsRefundQtyNormal<0) || (this.state.seatsRefundQtyNormal>this.state.resData.qtyNormal))
      return alert('Niepoprawna ilość biletów normalnych do zwrotu')
    if ((this.state.seatsRefundQtyReduced<0) || (this.state.seatsRefundQtyReduced>this.state.resData.qtyReduced))
      return alert('Niepoprawna ilość biletów ulgowych do zwrotu')
    if ((this.state.seatsRefundQtyNormal<=0) && (this.state.seatsRefundQtyReduced<=0))
      return alert('Niepoprawna ilość biletów do zwrotu')
//    if (!this.state.firstName)
//      return alert('Nie wprowadzono imienia pasażera')
//    if (!this.state.phone)
//      return alert('Nie wprowadzono nr telefonu pasażera')
//
    this.setState(
      {currState: REFUND_STATE_PENDING}
    )
    let refundReq={
      idReservation: this.state.idReservation,
      seatsRefundQtyNormal: this.state.seatsRefundQtyNormal,
      seatsRefundQtyReduced: this.state.seatsRefundQtyReduced,
      saveRefund: save,
      isFullRefund: (this.state.isFullRefund==='true'),
      agent: this.props.agentLogin,
    }

    var that=this
    fetchMB('refund', refundReq, true)
    .then(
      function(json){
        console.log('refund', json)
        if (json.status==='OK'){
          if (save)
            that.props.onClearResList();

          that.setState(
            {currState: (save ? REFUND_STATE_RESULT : REFUND_STATE_CALCRESULT),
             refundData: json,
            }
          )
        }
        else
          that.setError(json.errorMessage)
      },
      function(error){
        //console.log('error', error)
        that.setError("Bład komunikacji")
      }
    )
  }

  render(){
    if (!this.props.isLogged)
      return this.renderLogout();
    switch (this.state.currState){
      case REFUND_STATE_NEW:
        return this.renderNew()
      case REFUND_STATE_SHOWFORM:
        return this.renderForm();
      case REFUND_STATE_PENDING:
        return this.renderPending();
      case REFUND_STATE_RESULT:
        return this.renderResult();
      case REFUND_STATE_CALCRESULT:
        return this.renderCalcResult();
      case REFUND_STATE_ERROR:
        return this.renderError();
      default:
        return this.renderLogout();
    }
  }

  renderForm() {
    var lW=3 //left width
    var rW=9 //right width
    return (
      <Container fluid className="defForm">
        <h3>Formularz zwrotu</h3>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Wyjazd:</Label></Col>
          <Col sm={rW}>
              <span className="town">{this.state.resData.startTown}</span>
              <span className="street">{', ' + this.state.resData.startAddress}</span>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Przyjazd:</Label></Col>
          <Col sm={rW}>
              <span className="town">{this.state.resData.finishTown}</span>
            <span className="street">{', ' + this.state.resData.finishAddress}</span>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Data kursu:</Label></Col>
          <Col sm={rW}>
            <span className="startTime">{moment(this.state.resData.startDateTime).format('YYYY-MM-DD HH:mm')}</span>
            <span className="finishTime">{' - ' + moment(this.state.resData.finishDateTime).format('HH:mm')}</span>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Pasażer:</Label></Col>
          <Col sm={rW}>
              {this.state.resData.firstName} {this.state.resData.lastName}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Ilość biletów normalnych:</Label></Col>
          <Col sm={rW}>
              {this.state.resData.qtyNormal}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Ilość biletów ulgowych:</Label></Col>
          <Col sm={rW}>
              {this.state.resData.qtyReduced}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Wartość biletu:</Label></Col>
          <Col sm={rW}>
              {formatCurrency(this.state.resData.totalPrice)}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Rodzaj zwrotu:</Label></Col>
          <Col sm={rW}>
            <label>
              <input type="radio" name="isFullRefund" value="false"
                  checked={this.state.isFullRefund === 'false'}
                  onChange={this.handleInputChange} />
              Zwrot regulaminowy
            </label>
            {' '}
            <label>
              <input type="radio" name="isFullRefund" value="true"
                  checked={this.state.isFullRefund === 'true'}
                  onChange={this.handleInputChange} />
              Pełny zwrot
            </label>
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Ilość b. normalnych do zwrotu:</Label></Col>
          <Col sm={2}>
              <Input type="number"
              name="seatsRefundQtyNormal"
              value={this.state.seatsRefundQtyNormal}
              placeholder="Ilość biletów normalnych do zwrotu"
              required
              min="0"
              max={this.state.resData.qtyNormal}
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Ilość b. ulgowych do zwrotu:</Label></Col>
          <Col sm={2}>
              <Input type="number"
              name="seatsRefundQtyReduced"
              value={this.state.seatsRefundQtyReduced}
              placeholder="Ilość biletów ulgowych do zwrotu"
              required
              min="0"
              max={this.state.resData.qtyReduced}
              onChange={this.handleInputChange}
            />
          </Col>
        </Row>


        <Row className="align-items-center">
          <Col xs="0" sm={lW}></Col>
          <Col xs="4" sm={{size: 2, offset: 1}}><Button color="danger" size="lg" onClick={this.handleSubmit}>Zwróć</Button></Col>
          <Col xs="4" sm={{size: 2, offset: 1}}><Button color="danger" size="lg" onClick={this.handleCalcSubmit}>Przelicz</Button></Col>
          <Col xs="4" sm={{size: 2, offset: 1}}><Button color="danger" size="lg" onClick={this.handleCancel}>Anuluj</Button></Col>
        </Row>
      </Container>
    )
  }

  renderPending() {
    return (
      <div className="pendingText">
        Trwa wykonywanie zwrotu...
      </div>
    )
  }

  renderResultDetails(refund, lW=3, rW=9){
    return (
      <div>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Pasażer:</Label></Col>
          <Col sm={rW}>
              {this.state.resData.firstName} {this.state.resData.lastName}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Wartość biletu:</Label></Col>
          <Col sm={rW}>
              {formatCurrency(this.state.resData.totalPrice)}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Ilość zwracanych biletów normalnych:</Label></Col>
          <Col sm={rW}>
              {this.state.refundData.normalQty + ' z ' + this.state.resData.qtyNormal}
          </Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Ilość zwracanych biletów ulgowych:</Label></Col>
          <Col sm={rW}>
              {this.state.refundData.reducedQty + ' z ' + this.state.resData.qtyReduced}

          </Col>
        </Row>

        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Kwota potrącenia:</Label></Col>
          <Col sm={rW}>{formatCurrency(refund.deductionAmount)} ({refund.deductionPercent}%)</Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Kwota do zwrotu:</Label></Col>
          <Col sm={rW} className="amount">{formatCurrency(refund.amount)}</Col>
        </Row>
      </div>
    )
  }

  renderCalcResult(){
    var refund=this.state.refundData;
    var lW=3 //left width
    var rW=9 //right width
    return (
      <Container fluid className="defForm">
        <h3>Dane zwrotu</h3>

        {this.renderResultDetails(refund, lW, rW)}
        <Row>
          <Col xs="0" sm={lW}></Col>
          <Col xs="4" sm={{size: 2, offset: 1}}><Button color="danger" size="lg" onClick={this.handleSubmit}>Wykonaj zwrot</Button></Col>
          <Col xs="4" sm={{size: 2, offset: lW}}><Button color="danger" size="lg" onClick={this.handleCancel}>Powrót</Button></Col>
        </Row>
      </Container>
    )
  }

  renderResult(){
    var refund=this.state.refundData;
    var lW=3 //left width
    var rW=9 //right width
    return (
      <Container fluid className="defForm">
        <h3>Potwierdzenie zwrotu</h3>

        <Row className="align-items-center">
          <Col>Zwrot został zarejestrowany w systemie</Col>
        </Row>
        <Row className="align-items-center">
          <Col xs="12" sm={lW}><Label>Id rezerwacji:</Label></Col>
          <Col sm={rW}>{refund.idRefund}</Col>
        </Row>
        {this.renderResultDetails(refund, lW, rW)}
        <Row>
          <Col xs="0" sm={lW}></Col>
          <Col ><Button color="danger" size="lg" onClick={this.handleCancel}>Powrót</Button></Col>
        </Row>
      </Container>
    )
  }

  renderError(){
    return (
      <div>
        <h2>Błąd!!!</h2>
        <p>{this.state.errorDesc}</p>

        <Button color="danger" size="lg" onClick={this.handleCancel}>Anuluj</Button>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Refund);


// WEBPACK FOOTER //
// ./src/Refund.js